import useSWR from "swr";
import { apiUrls } from "../../utils/api";

export function useProjectCategories() {
  return useSWR(apiUrls.GetProjectCategories);
}
